/**
 * footbase?
 * football base
 * foobal
 * sundaybase
 * foothub
 * squadbase
 * squadhub
 * thelineup
 * huddles * huddles.club
 */
export const NAME = 'huddles'
